 
import React from 'react';
import { gql, useMutation } from '@apollo/client';

const RESOLVE_MISSING_EMAILS = gql`
  mutation ResolveMissingEmails {
    migrateEmails {
     message
    }
  }
`;

export const ResolveMissingEmailsPage = () => {
  const [resolveMissingEmails, { data, loading, error }] = useMutation(RESOLVE_MISSING_EMAILS);

  return (
    <div className="p-6 max-w-md mx-auto">
      <h1 className="text-2xl font-semibold mb-4">Migrate Emails</h1>
      <button
        onClick={() => resolveMissingEmails()}
        disabled={loading}
        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded disabled:opacity-50"
      >
        {loading ? 'Processing…' : 'Run Resolution'}
      </button>

      {error && (
        <div className="mt-4 text-red-500">
          Error: {error.message}
        </div>
      )}

      {data?.resolveMissingEmails && (
        <div className="mt-4 text-green-600">
          ✔ {data.migrateEmails.message} (Processed {data.migrateEmails.count} messages)
        </div>
      )}
    </div>
  );
}